import { render, staticRenderFns } from "./DragTool.vue?vue&type=template&id=23534a80"
import script from "./DragTool.vue?vue&type=script&lang=js"
export * from "./DragTool.vue?vue&type=script&lang=js"
import style0 from "./DragTool.vue?vue&type=style&index=0&id=23534a80&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23534a80')) {
      api.createRecord('23534a80', component.options)
    } else {
      api.reload('23534a80', component.options)
    }
    module.hot.accept("./DragTool.vue?vue&type=template&id=23534a80", function () {
      api.rerender('23534a80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/components/formSetting/components/form-create-designer/src/components/DragTool.vue"
export default component.exports